import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.accountTitleBalance.query,
    method: 'post',
    data: requestBody
  })
}
// 查询列表
export function loadAccountTitleBalance(requestBody) {
  return request({
    url: URL.finance.accountTitleBalance.loadAccountTitleBalance,
    method: 'post',
    data: requestBody
  })
}
